import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'search-common-commands',
    templateUrl: './search-common-commands.component.html',
    styleUrls: ['./search-common-commands.component.scss'],
    standalone: false
})
export class SearchCommonCommandsComponent {

    @Input() useExport: boolean = true;
    @Input() useGlobalSearch: boolean = true;
    @Input() useAdvancedSearch: boolean = true;
    @Input() showPrint: boolean = true;

    @Input() searchTerm: string;
    @Output() searchTermChange = new EventEmitter<string>();
    @Input() globalSearchPlaceholder = 'Screens.Appointments.Search.Actions.GlobalSearchPlaceholder';

    @Input() showAdvanced: boolean;
    @Output() showAdvancedChange = new EventEmitter<boolean>();

    @Output() print = new EventEmitter<boolean>();
}
